// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__28tLx","row":"Node_row__Ee6ec","label":"Node_label__3AUdB","footer":"Node_footer__2NqsQ"};